import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';
import Button from '@hpstellar/core/visId/Button';
import { ChevronRight } from '@hpstellar/vis-icons';

import { SUPPORT_HOME_PAGE } from '../util';

import './css/search-support-static-link.less';

export default  () => {
    const isMobile = useSelector(state => {
        try{
            return state.ui.customBreakpoints.visId === 'xsmall'
        }catch(e){}
        return false;
    });
    const iconProps = useMemo(() => isMobile ? {} : {
        endIcon: <ChevronRight size="s" />
    }, [isMobile]);
    
    return (
        <div className='srp-support-home-page-link-container'>
            <Button 
                className='srp-support-home-page-link' 
                to={SUPPORT_HOME_PAGE} 
                theme='accent'
                variation='tertiary'
                {...iconProps}
            >
                Can't see your product? Visit Support
            </Button>
        </div>
    )
};